// import React from "react";

export default function NumClickTags(props){
	if(props.value < 0){ return "N/A"; }

	return props.value;
}
